import { useEffect } from "react"

// Updates the height of a <textarea> when the value changes.
const useAutosizeTextArea = (
  textAreaRef: HTMLTextAreaElement | null,
  value: string,
) => {
  useEffect(() => {
    if (textAreaRef) {
      // We need to reset the height momentarily to get the correct scrollHeight for shrinking.
      // eslint-disable-next-line react-hooks/immutability
      textAreaRef.style.height = "0px"
      const scrollHeight = textAreaRef.scrollHeight

      // We then set the height directly, outside of the render loop
      // Trying to set this with state or render props would cause an infinite loop.
       
      textAreaRef.style.height = `${String(scrollHeight)}px`
    }
  }, [textAreaRef, value])
}

export default useAutosizeTextArea
